import React from 'react'
import logo from '../img/logo.png'
import { FormattedMessage, Link } from "gatsby-plugin-intl"
import Language from "../components/Language"
import background from '../img/header-background.png'

const Navbar = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      navBarActiveClass: '',
    }
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: 'is-active',
            })
          : this.setState({
              navBarActiveClass: '',
            })
      }
    )
  }

  render() {
    return (
      <nav style={{
        backgroundImage: `url(${background})`,
        borderBottom: `solid 20px #599CF5`,
        height: `127px`
      }} className="navbar is-transparent"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item logo" title="Logo">
              <img src={logo} alt="Voiceovers" />
            </Link>
            {/* Hamburger menu */}
            <div
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered">
              <Link className="navbar-item" to="/">
                <FormattedMessage id="go_announcers" />
              </Link>
              <Link className="navbar-item" to="/about">
                <FormattedMessage id="go_about" />
              </Link>
              <Link className="navbar-item" to="/contact">
                <FormattedMessage id="go_contact" />
              </Link>
            </div>
            <div className="navbar-end has-text-centered">
              <div className="navbar-item">
                <Language />
              </div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Navbar
